import * as React from "react";
import { Context } from "./_context";
export const CategoryDiyIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5.5 3.5a3.5 3.5 0 0 1 3.346 4.528L13 10.798l8.445-5.63 1.11 1.664-7.752 5.167 7.752 5.169-1.11 1.664L13 13.202 8.846 15.97a3.5 3.5 0 1 1-1.11-1.664L11.195 12l-3.46-2.308A3.5 3.5 0 1 1 5.5 3.5Zm0 12a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm0-10a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z", fill: "currentColor" }));
  return iconset[size];
};
CategoryDiyIcon.iconId = "w634MN";
